<app-label flow="column"
           name="{{'admin.strain.registry.details.measurements.observations' | translate}}"
           value="{{measurement?.observations}}">
</app-label>
<div class="values">
    <app-label flow="column"
               name="{{'admin.strain.registry.details.measurements.minValue' | translate}}"
               value="{{measurement?.minValue}}">
    </app-label>
    <app-label flow="column"
               name="{{'admin.strain.registry.details.measurements.maxValue' | translate}}"
               value="{{measurement?.maxValue}}">
    </app-label>
</div>
<app-label flow="column"
           name="{{'admin.strain.registry.details.measurements.measurer' | translate}}"
           value="{{measurement?.measuredBy?.fullName}}"
           valueIcon="fa-user">
</app-label>
<div class="reports">
    <p class="label">{{'admin.strain.registry.details.measurements.reports' | translate}}</p>


    <ng-container
        *ngTemplateOutlet="measurement?.reports && measurement?.reports?.length ? reports : noReports; context: { reports: measurement.reports }">
    </ng-container>
</div>
<ng-template #reports let-reports="reports">
    <div *ngFor="let report of reports" class="report-title">
        <app-strain-report-card [canDelete]="hasPermission()"
                                [reportFile]="report"
                                (delete)="onDeleteReport($event)"
                                (download)="onReportClick($event)">
        </app-strain-report-card>
    </div>
</ng-template>

<ng-template #noReports>{{'admin.strain.registry.details.measurements.noReports' | translate}}</ng-template>
